import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/jobGroups'
import Component from 'components/JobGroups'

export default createListViewContainer({ actions, selectors: selectors.jobGroups })(Component)
